// Mirror of SPECIALISATION_LABELS exists in apps/bridge/app/(app)/groups/[id]/_lib/group-helpers.ts
// — kept separate as Finder and Bridge share no common package.
export const SPECIALISATION_LABELS: Record<string, string> = {
  addiction_supporter_recovery: "Addiction & Supporter Recovery",
  addiction_recovery: "Addiction Recovery",
  supporter_recovery: "Supporter Recovery",
  pornography_addiction_recovery_men: "Pornography Recovery (Men)",
  pornography_addiction_recovery_women: "Pornography Recovery (Women)",
  spouses_pornography_addiction_recovery: "Spouses – Pornography Recovery",
};

// Each filter option matches one or more DB specialisation values so that
// mixed groups (addiction_supporter_recovery) surface under both audience filters.
export const GROUP_TYPE_OPTIONS = [
  {
    label: "Addiction Recovery",
    matches: ["addiction_recovery", "addiction_supporter_recovery"],
    value: "addiction_recovery",
  },
  {
    label: "Supporter Recovery",
    matches: ["supporter_recovery", "addiction_supporter_recovery"],
    value: "supporter_recovery",
  },
  {
    label: "Pornography Recovery (Men)",
    matches: ["pornography_addiction_recovery_men"],
    value: "pornography_addiction_recovery_men",
  },
  {
    label: "Pornography Recovery (Women)",
    matches: ["pornography_addiction_recovery_women"],
    value: "pornography_addiction_recovery_women",
  },
  {
    label: "Spouses – Pornography Recovery",
    matches: ["spouses_pornography_addiction_recovery"],
    value: "spouses_pornography_addiction_recovery",
  },
];

/** Returns true if a group's specialisation falls under the selected filter option. */
export function matchesGroupType(
  specialisation: string | null,
  filterValue: string
): boolean {
  const option = GROUP_TYPE_OPTIONS.find((o) => o.value === filterValue);
  return option
    ? option.matches.includes(specialisation ?? "")
    : specialisation === filterValue;
}
